export default __webpack_public_path__ + "static/media/49.d52471cb.png";